const SERVICE_OPTIONS = [
    'BASIC',
    'STANDARD',
    'PREMIUM',
];

const ADDITIONS = [
    'AUTO_CHECKIN',
    'BAGGAGE_ASSISTANCE',
    'CONFIRMATION_SMS',
    'ESTA',
    'EVISA',
];

const FARE_RULES = [
    'CLASSIC',
    'FLEXIBLE_FARE_RULE',
    'PREMIUM_FARE_RULE',
];

const GUARANTEES = [
    'CANXSELF',
    'FLEXSELF',
];

const FLEX_THIRD_PARTY = ['FLEXRB160', 'FLEXRB156', 'FLEXUK164', 'FLEX_AX04', 'UKFLEX_AX11'];

const MOBILE_ANCILLARIES_CONTINUE_BUTTON_VALUES = [
    'MOBILE:PRIME',
    'MOBILE:INSURANCES',
    'MOBILE:CANX',
    'MOBILE:FLEX',
    'MOBILE:ADDITIONS',
];

const MOBILE_SO_CONTINUE_BUTTON_VALUES = [
    'MOBILE:SO',
];

const INSURANCES = [
    'ASTONL162',
    'COMPREH163',
    'CNXAST152',
    'CNXAST158',
    'CNXFLT151',
    'CNXFHL154',
    'CNXHOT155',
    'CNXFHL157',
    'G-AIRD01',
    'G-AIRD02',
    'G-AIRI01',
    'G-AIRI02',
    'NEWHUB162',
    'SAFINS165',
    '56-0009760',
    '1-26-5251592',
    'COMPRE_AX09',
    'CANASS_AX02',
    'UKMULTI_AX12',
    'CANX_AX01',
    'CANXDP_AX03',
    'UKCANX_AX10',
    'HUB_AX05',
    ...FLEX_THIRD_PARTY,
];

export const ADDITIONAL_PRODUCTS_MODULES = {
    FARE_RULES: 'additional-products:fare-rules',
    ANCILLARIES_MODULE: 'additional-products:ancillaries-module',
    SERVICE_OPTIONS: 'additional-products:service-options',
    PAYMENT_BUTTON: 'additional-products:payment-button',
    NAGS: 'additional-products:nags',
    ANCILLARIES_STEP: 'additional-products:ancillaries-step',
    MOBILE_CONTINUE_BUTTON: 'additional-products:continuance',
};

const getProductLabels = (module = '', products = []) => products.map((product) => `${module}:${product}`);

export default new Set([
    ...Object.values(ADDITIONAL_PRODUCTS_MODULES),
    ...getProductLabels(ADDITIONAL_PRODUCTS_MODULES.FARE_RULES, FARE_RULES),
    ...getProductLabels(ADDITIONAL_PRODUCTS_MODULES.SERVICE_OPTIONS, SERVICE_OPTIONS),
    ...getProductLabels(ADDITIONAL_PRODUCTS_MODULES.ANCILLARIES_MODULE, GUARANTEES),
    ...getProductLabels(ADDITIONAL_PRODUCTS_MODULES.ANCILLARIES_MODULE, INSURANCES),
    ...getProductLabels(ADDITIONAL_PRODUCTS_MODULES.ANCILLARIES_MODULE, ADDITIONS),
    ...getProductLabels(ADDITIONAL_PRODUCTS_MODULES.PAYMENT_BUTTON, GUARANTEES),
    ...getProductLabels(ADDITIONAL_PRODUCTS_MODULES.PAYMENT_BUTTON, FLEX_THIRD_PARTY),
    ADDITIONAL_PRODUCTS_MODULES.ANCILLARIES_STEP,
    ...getProductLabels(ADDITIONAL_PRODUCTS_MODULES.MOBILE_CONTINUE_BUTTON, MOBILE_ANCILLARIES_CONTINUE_BUTTON_VALUES),
    ...getProductLabels(ADDITIONAL_PRODUCTS_MODULES.MOBILE_CONTINUE_BUTTON, MOBILE_SO_CONTINUE_BUTTON_VALUES),
]);
